import { Box, Typography } from '@mui/material';

type Props = {
  label: string;
  value: string;
  testId: string;
};

export function TransactionHistoryDetailField({ label, value, testId }: Readonly<Props>) {
  return (
    <Box component="dl" sx={{ m: 0 }} data-testid={testId}>
      <Typography component="dt" variant="body2" sx={{ fontWeight: 700 }}>
        {label}
      </Typography>
      <Typography component="dd" variant="body2" sx={{ m: 0 }}>
        {value}
      </Typography>
    </Box>
  );
}